export const CountToPurchase = {
    /**
     * @constant
     * @type {number}
     */
    purchaseOne: 1,
    /**
     * @constant
     * @type {number}
     */
    purchaseFive: 5,
    /**
     * @constant
     * @type {number}
     */
    purchaseTen: 10,
    /**
     * @constant
     * @type {number}
     */
    purchaseMax: -1
}